import { Checkbox, Form, FormInstance } from 'antd';
import ChevronDownIcon from 'assets/icons/chevron-down-2.svg';
import { toggleChecking } from 'presentation/redux/features/CU/CU05504Slice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { generateArrayToObject } from '../helper';
import { MasterAreaState } from '../models/Master';

interface props {
    data: MasterAreaState;
    form: FormInstance<any>;
    checkParentedChecked?: () => void;
    getListChild?: (item: MasterAreaState) => void;
    maxLevel: number;
}

export const CheckBoxGroup = ({
    data,
    form,
    checkParentedChecked,
    getListChild,
    maxLevel,
}: props) => {
    const dispatch = useAppDispatch();
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
    const [objectValueAll, setObjectValueAll] = useState<string[]>([]);
    const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

    useEffect(() => {
        const value = getValue([], data);
        setObjectValueAll(value ?? []);
        setIsCollapsed((data?.level ?? 0) < maxLevel);
    }, [JSON.stringify(data)]);

    useEffect(() => {
        if (isExpanded && !data.wasRequestd) {
            getListChild && getListChild(data);
        }
    }, [isExpanded]);

    const getValue = (value: string[], data: MasterAreaState) => {
        if (data.children) {
            data.children.forEach((element) => {
                value.push(element.code);
                getValue(value, element);
            });
            return value;
        }
        return;
    };

    const onChildrenChange = () => {
        const isEveryTrue = objectValueAll.every((element) =>
            form.getFieldValue(`id${element}`) ? true : false,
        );
        form.setFieldValue(`id${data.code}`, isEveryTrue);
    };

    const onIsCheckAllChange = (e?: any): void => {
        const isChecked = e.target.checked;
        if (isChecked) form.setFieldsValue(generateArrayToObject(objectValueAll, true));
        else {
            const resetFielts = objectValueAll.map((element) => `id${element}`);
            form.resetFields(resetFielts);
        }
        if (checkParentedChecked) checkParentedChecked();
        dispatch(toggleChecking());
    };

    return (
        <section
            style={{
                width: '100%',
            }}
        >
            <div {...getToggleProps()}>
                <section
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        height: 52,
                        alignItems: 'center',
                        borderBottom: '1px solid rgba(207, 207, 207, 0.4)',
                        paddingLeft: (data?.level ?? 0) * 24,
                    }}
                    className="button-style"
                >
                    <div
                        onClick={(event) => {
                            event.stopPropagation();
                        }}
                    >
                        <Form.Item
                            style={{ margin: 0, padding: 0 }}
                            name={`id${data.code}`}
                            label={false}
                            valuePropName="checked"
                        >
                            <Checkbox onChange={onIsCheckAllChange} className="checkbox-font-2">
                                {data?.name ?? ''}
                            </Checkbox>
                        </Form.Item>
                    </div>

                    <section className="center-inside">
                        <div className="number-property center-inside">{data?.numberProperty}</div>
                        {isCollapsed && (
                            <div className="button-style center-inside" style={{ marginLeft: 8 }}>
                                <img
                                    alt=""
                                    src={ChevronDownIcon}
                                    className={`cu05504-icon ${
                                        isExpanded ? 'cu05504-icon-active' : ''
                                    }`}
                                />
                            </div>
                        )}
                    </section>
                </section>
            </div>
            <div {...getCollapseProps()}>
                <section
                    className="content"
                    style={{
                        width: '100%',
                        height: 'fit-content',
                    }}
                >
                    {data.children &&
                        data.children?.length > 0 &&
                        data.children.map((element, index) => (
                            <CheckBoxGroup
                                form={form}
                                key={index}
                                data={element}
                                checkParentedChecked={onChildrenChange}
                                getListChild={getListChild}
                                maxLevel={maxLevel}
                            />
                        ))}
                </section>
            </div>
        </section>
    );
};
